function initVideoTabs() {
  const inspirationSection = document.querySelector("#OurInspiration");

  if (!inspirationSection) {
    return;
  }

  const cards = inspirationSection.querySelectorAll('.video__container-grid .video');

  const tags = Array.from(inspirationSection.querySelectorAll(".tag"));
  const playButtons = Array.from(
    inspirationSection.querySelectorAll(".video__play")
  );

  if (!tags.length || !playButtons.length) {
    return;
  }

  const loadMoreButton = inspirationSection.querySelector(".load-more");

  cards.forEach((card) => {
    initPlayButton(card, cards);
  });

  loadMoreButton.addEventListener("click", () => {
    showVideos("all", cards);
    loadMoreButton.classList.add("hide");
  });

  tags.forEach((tag) =>
    tag.addEventListener("click", () => {
      const activeTag = tags.find((item) => item.classList.contains("active"));

      if (!loadMoreButton.classList.contains("hide")) {
        loadMoreButton.classList.add("hide");
      }

      activeTag.classList.remove("active");
      tag.classList.add("active");

      pauseAllVideos(cards);
      showVideos(tag.dataset.tag, cards);
    })
  );

  function showVideos(tag, vList) {
    if (!tag) {
      return;
    }

    const videos = Array.from(vList);

    if (tag != "all") {
      videos.forEach((video) => video.classList.add("hide"));
      const taggedVideos = videos.filter((item) => item.dataset.tag === tag);
      taggedVideos.forEach((video) => video.classList.remove("hide"));
    } else {
      videos.forEach((video) => video.classList.remove("hide"));
    }
  }
}

function playVideoCards() {
  const cards = document.querySelectorAll(".video-file-card");

  if (!cards) {
    return;
  }

  cards.forEach((card) => {
    initPlayButton(card, cards);
  });
}

function initPlayButton(vObj, vList) {
  const playButton = vObj.querySelector(".video__play");
  const playButtonImage = vObj.querySelector(".video__play svg");
  const video = vObj.querySelector("video");
  const spinner = vObj.querySelector(".video__spinner");

  playButton.addEventListener("click", () => {
    video.onwaiting = function () {
      spinner.classList.remove("hide");
    };

    video.onplaying = function () {
      spinner.classList.add("hide");
    };

    if (video.classList.contains("lazy")) {
      const videoSources = Array.from(video.querySelectorAll("source"));

      if (!videoSources.length) {
        return;
      }

      videoSources.forEach((source) => {
        source.src = source.dataset.src;
      });

      video.load();
      video.classList.remove("lazy");
    }

    if (video.paused) {
      pauseAllVideos(vList);
      playButtonImage.classList.add("hide");
      video.play();
    } else {
      playButtonImage.classList.remove("hide");
      video.pause();
    }
  });
}

function pauseAllVideos(video_cards) {
  video_cards.forEach((video) => {
    const videoPlayer = video.querySelector("video");
    const playButtonImage = video.querySelector(".video__play svg");

    playButtonImage.classList.remove("hide");
    videoPlayer.pause();
  });
}

function initMobileVideoSlider() {
  $(".video__container-grid").slick({
    responsive: [
      {
        breakpoint: 9999,
        settings: "unslick",
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: true,
          centerPadding: "24px",
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
          arrows: false,
          initialSlide: 1,
          slide: ".slickElement",
        },
      },
    ],
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initVideoTabs();
  playVideoCards();
  // initMobileVideoSlider();
});
